// Textos y estado de los cupones, compartidos por la lista y los formularios.

export const COUPON_DISCOUNT_TYPES = [
  { code: "percentage", name: "Percentage off the order" },
  { code: "fixed", name: "Fixed amount off the order" },
  { code: "shipping", name: "Free shipping only" },
  { code: "product", name: "By product / category" }
];

// Mismos valores que el enum de coupons_v2_products y coupons_v2_categories
export const RULE_DISCOUNT_TYPES = [
  { code: "percentage", name: "% off" },
  { code: "amount", name: "$ off each unit" },
  { code: "fixed_final_price", name: "Final price per unit" }
];

export function ruleDiscountText(rule) {
  const amount = Number(rule.amount);
  switch (rule.discountType) {
    case "percentage":
      return `${amount}% off`;
    case "amount":
      return `$${amount.toFixed(2)} off each`;
    case "fixed_final_price":
      return `Final price $${amount.toFixed(2)}`;
    default:
      return rule.discountType;
  }
}

export function couponDiscountText(coupon) {
  const amount = Number(coupon.amount);
  switch (coupon.discountType) {
    case "percentage":
      return `${amount}% off`;
    case "fixed":
      return `$${amount.toFixed(2)} off`;
    case "shipping":
      return "Free shipping";
    case "product":
      return "By product / category";
    default:
      return coupon.discountType;
  }
}

// active | scheduled | expired | inactive (las fechas vienen como YYYY-MM-DD)
export function couponState(coupon, today = localToday()) {
  if (Number(coupon.status) !== 1) return "inactive";
  if (coupon.fromDate && coupon.fromDate > today) return "scheduled";
  if (coupon.toDate && coupon.toDate < today) return "expired";
  return "active";
}

export const COUPON_STATES = {
  active: { name: "Active", badge: "bg-green-100 text-green-800" },
  scheduled: { name: "Scheduled", badge: "bg-blue-100 text-blue-800" },
  expired: { name: "Expired", badge: "bg-gray-200 text-gray-700" },
  inactive: { name: "Inactive", badge: "bg-yellow-100 text-yellow-800" }
};

// YYYY-MM-DD en la hora local (toISOString da la fecha UTC)
export function localToday() {
  return new Date().toLocaleDateString("en-CA");
}
